import React from 'react';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface PlayerAppearanceProps {
  onAction: (action: string, data?: any) => void;
}

export const PlayerAppearance: React.FC<PlayerAppearanceProps> = ({ onAction }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Appearance</div>
      <button
        style={{ ...buttonStyle, background: '#8e44ad', borderColor: '#9b59b6' }}
        onClick={() => onAction('toggle_editor')}
      >
        ✨ Edit Character
      </button>
      <button
        style={buttonStyle}
        onClick={() => onAction('randomize_appearance')}
      >
        🎲 Randomize Look
      </button>
    </>
  );
};
